<template>
  <div class="contacts-video-route">
    <button class="contacts-video-route__btn _preview" :style="`background-image: url('${data.preview}')`" @click="showPopup">
      <svg>
        <use xlink:href="/assets/blueant/assets/sprite.svg#sprite-play"></use>
      </svg>
    </button>
    <button class="contacts-video-route__btn _copy" @click="copyLink">
      <span v-if="isCopied">Скопировано</span>
      <template v-else>
        <span >Скопировать ссылку на ролик</span>
        <svg>
          <use xlink:href="/assets/blueant/assets/sprite.svg#sprite-copy"></use>
        </svg>
      </template>
    </button>
    <d-popup-simple v-model="showPopupVideo" mod="contact-video" @closed="closePopup">
      <div v-if="showPopupVideo" class="contacts-video-route__popup">
        <video  autoplay controls loop>
          <source :src="data.url" :type="videoFormat">
        </video>
      </div>
    </d-popup-simple>
  </div>
</template>

<script>
import DPopupSimple from "@components/molecules/DPopupSimple.vue";
import DObjectGalleryPopup from "@components/molecules/DObjectGalleryPopup.vue";

export default {
  name: "DContactsVideoRoute",
  components: {DObjectGalleryPopup, DPopupSimple},
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      showPopupVideo: false,
      tempVideoLink: "yandex.ru",
      isCopied: false
    }
  },
  computed: {
    videoFormat() {
      const name = this.data.url.split('.')
      return `video/${name[name.length - 1]}`
    }
  },
  methods: {
    showPopup() {
      this.showPopupVideo = true
    },
    closePopup() {
      this.showPopupVideo = false
    },
    async copyLink() {
      try {
        await navigator.clipboard.writeText(`${window.location.origin}${this.data?.url}`);
        this.isCopied = true
        setTimeout(() => {
          this.isCopied = false
        }, 3000)
      } catch (error) {
        console.error(error.message);
      }


    },
  }
}
</script>

<style scoped>

</style>